/* eslint-disable indent */
<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="LISTA DE USUÁRIOS" :data="tableData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="4" :totalPDF="total" titleReport="Relátorio de Usuários">
                <md-button v-if="permissoes.usuarioCreate" class="md-button md-success md-just-icon md-round" :to="{ name: 'usuarioCreate' }">
                    <i class="fas fa-plus"></i>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-15 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Situação</label>
                                    <md-select v-model="usuario.situacao_id" name="pages">
                                        <md-option value="1">ATIVO</md-option>
                                        <md-option value="2">INATIVO</md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-25 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Nome ou Usuário" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-15 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                            <div class="md-layout-item md-size-30 md-xsmall-size-100">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise no resultado da busca aqui." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="NOME" style="width: 35%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="APELIDO" style="width: 20%">{{ item.apelido }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="USUÁRIO" style="width: 20%" md-sort-by="usuario">{{ item.usuario }}</md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permissoes.usuarioUpdate" @click="editar(item.id)">
                                        EDITAR <md-icon class="text-warning">edit</md-icon>
                                    </md-menu-item>
                                     <md-menu-item v-if="permissoes.usuarioReadNiveisAcesso" @click="niveisAcessoUsuario(item.id)">
                                        NÍVEIS DE ACESSO <md-icon class="text-success">security</md-icon>
                                    </md-menu-item>
                                     <md-menu-item v-if="permissoes.usuarioReadEmpresa" @click="empresaUsuario(item.id)">
                                        EMPRESAS <md-icon class="text-success">business</md-icon>
                                    </md-menu-item>
                                    <md-menu-item @click="visualizar(item.id)">
                                        VISUALIZAR<md-icon class="text-info">visibility</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="usuario.situacao_id == 2 && permissoes.usuarioInactivate" @click="inativar(item.id, item.nome)">
                                        ATIVAR<md-icon class="text-success">thumb_up_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="usuario.situacao_id == 1 && permissoes.usuarioActivate" @click="inativar(item.id, item.nome)">
                                        INATIVAR<md-icon class="text-danger">thumb_down_alt</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.usuarioResetPassword" @click="showReset(item.id)">
                                        RESETAR<md-icon class="text-info">vpn_key</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.usuarioDelete" @click="excluir(item.id, item.nome)">
                                        EXCLUIR<md-icon class="text-danger">delete</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.usuarioEliminate" @click="apagar(item.id, item.nome)">
                                        DELETAR<md-icon class="text-danger">delete_forever</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import Swal from "sweetalert2";

export default {
    name: 'ReadUsuario',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    mixins: [TableSearch, Notify, preLoader],

    data() {
        return {
            usuario: {
                situacao_id: 1
            },
            permissoes: this.$store.state.usuario.permissao,
            rotaInactivate: 'usuarios/inativar/',
            rotaActivate: 'usuarios/ativar/',
            titleInactivate: 'INATIVAR?',
            rotaDeletar: 'usuarios/',
            rotaExcluir: 'usuarios/excluir/',
            columnsPDF: [15, 85, 50, 30],
            headRowsPDF: ['ID', 'NOME', 'USUÁRIO', 'SITUAÇÃO'],
            fildsTXT: ['id', 'nome', 'usuario', 'situacao'],
            bodyRowsPDF: ['id', 'nome', 'usuario', 'situacao'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "NOME",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "USUÁRIO",
                    field: "usuario",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "SITUAÇÃO",
                    field: "situacao",
                    dataFormat: this.upperCaseFormat
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                busca: ''
            }
        };
    },

    watch: {
        'usuario.situacao_id': function (value) {
            this.read()
            this.titleInactivate = value == 1 ? 'INATIVAR?' : 'ATIVAR?'
        },
    },

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            let loader = this.openLoader('dots');
            this.buscar.situacao_id = this.usuario.situacao_id
            pagi = pagi || this.$urlAPI + 'usuarios/buscar'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.usuario]).includes(this.toLower(term)))
            }
            return items
        },

        editar(id) {
            this.$router.push({
                name: 'usuarioUpdate',
                params: {
                    id: id
                }
            })
        },

        visualizar(id) {
            this.$router.push({
                name: 'usuarioView',
                params: {
                    id: id
                }
            })
        },

        niveisAcessoUsuario(id) {
            this.$router.push({
                name: 'usuarioReadNiveisAcesso',
                params: {
                    id: id
                }
            })
        },

        empresaUsuario(id) {
            this.$router.push({
                name: 'usuarioReadEmpresa',
                params: {
                    id: id
                }
            })
        },

        inativar(id, nome) {
            this.handleInactivate(id, nome)
        },

        showReset(id) {
            Swal.fire({
                title: 'RESETAR A SENHA DO USUÁRIO?',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: 'RESETAR',
                cancelButtonText: 'SAIR'
            }).then((result) => {
                if (result.value) {
                    this.resetPassword(id)
                }
            })
        },

        resetPassword(id) {
            this.$http.put(this.$urlAPI + 'usuarios/resetar-password/' + id)
                .then(response => {
                    if (response.data.status) {
                        this.success(response.data.message)
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        excluir(id, nome) {
            this.handleDelete(id, nome)
        },

        apagar(id, nome) {
            this.deletar = true
            this.handleDelete(id, nome)
        }
    },

};
</script>

<style>
.menuTable {
    margin-right: 50% !important;
}

.menuTableItem {
    font-weight: bold;
}
</style>
